<template>
  <b-card :title="`IPG rolling ${vectorName}`">
    <Spinner v-if="loading"/>
    <template >
      <b-row>
        <b-col cols="5">
          <MonthPicker v-model="date"/>

          <div class="text-center m-3">
            <h2>
              <Delta :value-delta="delta" :decimal-places="1"/>
            </h2>
          </div>

          <div class="IPG-months">
            <div>{{ date.format(MONTH_DATE_FORMAT) }} : {{ selectedMonthIPG | formatDecimal(3) }}</div>
            <div>{{ previousMonth.format(MONTH_DATE_FORMAT) }} : {{ previousMonthIPG | formatDecimal(3) }}</div>
          </div>
        </b-col>

        <b-col cols="7" >
          <div style="height:300px;" :id="amChartId"></div>
          <!-- <apexchart type="line" height="250" :options="chartOptions" :series="series"/> -->
        </b-col>
      </b-row>
    </template>
  </b-card>
</template>

<script>
import vectorMixin from './vector';
import chartMixin from './chart';
import moment from 'moment';
import {ACTION_IPG} from '@/store/modules/dashboard/actions';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4lang_it_IT from "@amcharts/amcharts4/lang/it_IT";
import { makeid } from './helpers';


const MONTH_DATE_FORMAT = 'MMMM YYYY';

export default {
  mixins: [vectorMixin, chartMixin],

  props: {
    vector: {
      required: true,
      type: String,
    },
  },

  data() {
    return {
      chartId: 'IPG',
      amChartId: makeid(),
      localDate: moment(),
      dateComparisonType: 'month',
      MONTH_DATE_FORMAT,
      series: [],
      chartOptions: null,
      delta: null,
      values: [],
      chart: undefined
    }
  },

  created() {
    if (!this.isLockWidgets) {
      this.date = moment().subtract(2, 'months');
    }
  },

  mounted() {
    this.loadData();
  },

  beforeDestroy() {
    this.unload();
  },


  computed: {
    previousMonth() {
      return moment(this.date).subtract(1, 'months');
    },

    selectedMonthIPG() {
      return this.findMonthIPG(this.date);
    },

    previousMonthIPG() {
      return this.findMonthIPG(this.previousMonth);
    },

    vectorName() {
      return this.$store.getters['vectors/getName'](this.vector);
    },
  },

  methods: {
    async loadData() {
      if (this.loading) {
        return;
      }

      try {
        this.loading = true;

        const details = await this.$store.dispatch(
          `dashboard/${ACTION_IPG}`,
          {
            vector: this.vector,
            month: this.date,
          },
        );

        if (!details) {
          return;
        }

        const {delta, item, months} = details;
        this.delta = delta;

        this.values = item.values;
        const values = item.values.map((value,i) => {
          return  {
            value: value.IPGRolling,
            date:  moment(months[i], 'MM-YYYY').format('MMM YYYY')
          }
        });

        // this.series[0] = {data: values, name: item.name};
        // this.chartOptions.xaxis.categories = months.map((monthDate) =>
        //   moment(monthDate, 'MM-YYYY').format('MMM YYYY')
        // );

        // let amChartData =  values.map

        this.createAmChart(values)

      } finally {
        this.loading = false;
      }

    },

    findMonthIPG(monthDate) {
      if (!this.values) {
        return null;
      }

      const searchMonth = monthDate.format('MM-YYYY');
      const value = this.values.find((value) => searchMonth === value.date);

      return value ? value.IPGRolling : 0;
    },

    setChartOptions() {
      const titleFormatter = (val, opts) => {
        const title = opts.w.config.title.text;

        if (!title) {
          return val;
        }

        return `${val} (${title})`;
      };
      const tooltip = {
        title: {
          formatter: titleFormatter
        },
        formatter: (v, o) => {
          return v ? v.toFixed(2) : null;
        }
      };

      this.chartOptions = {
        ...this.defaultChartOptions,

        xaxis: {categories: []},
        yaxis: {
          title: {text: ''},

          labels: {
            formatter: x => this.$options.filters.formatDecimal(x),
          },
        },
        tooltip: {
          y: (new Array(2)).fill(tooltip)
        },

        markers: {
          size: [5, 0],

          hover: {size: 7},
        },
      }
    },

    createAmChart(values){
      let chart = am4core.create(this.amChartId, am4charts.XYChart);
      chart.language.locale = am4lang_it_IT;
      chart.language.locale["_decimalSeparator"] = ",";
      chart.language.locale["_thousandSeparator"] = "'";
      chart.data = values;
      chart.cursor = new am4charts.XYCursor();

      var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.renderer.grid.template.disabled = true;
      categoryAxis.dataFields.category = "date";
      categoryAxis.cursorTooltipEnabled = false;
      categoryAxis.renderer.minGridDistance = 10;
      categoryAxis.renderer.labels.template.rotation = -45;
      categoryAxis.renderer.labels.template.verticalCenter = "top";
      categoryAxis.renderer.labels.template.horizontalCenter = "right";
      // Create value axis
      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.cursorTooltipEnabled = false;

      // Create series
      var lineSeries = chart.series.push(new am4charts.LineSeries());
      lineSeries.dataFields.valueY = "value";
      lineSeries.dataFields.categoryX  = "date";
      lineSeries.strokeWidth = 4;
      lineSeries.stroke = am4core.color("#6995a7");
      lineSeries.tooltipText = "{date}\n [#6995a7]● [/] IPG EE {valueY.formatNumber('#.00')}";
      lineSeries.tooltip.getFillFromObject = false;
      lineSeries.tooltip.autoTextColor = false;
      lineSeries.tooltip.label.propertyFields.fill = am4core.color('#FFFFFF');
      lineSeries.tooltip.label.fill = am4core.color("black");


      // create Bullet on line
      var circleBullet = lineSeries.bullets.push(new am4charts.CircleBullet());
      circleBullet.circle.fill = am4core.color("#6995a7");
      this.chart = chart;
    },

    unload() {
      if(this.chart){
        this.chart.dispose();
        this.chart = undefined;
      }
    },
  },
}
</script>

<style>
.IPG-months > div {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/VectorWidgets/widgets/IPG.vue